import React, {Component} from 'react';
import DingdingCode from "../DingdingCode";
import './index.css'

class DingdingTeamLogin extends Component {
    render() {
        return (
            <div className="DingdingTeamLogin">
                <div className="title">
                    {React.language('dingding.code.team.login')}
                </div>
                <DingdingCode APPID={window.data_config.team_data.appid} params={window.location.href} />
                <div className="teamName">
                    【{window.data_config.team_data.corp_name}】
                </div>
            </div>
        );
    }
}

export default DingdingTeamLogin;